var map = {
	"./med-quindio/GenialSkills-logo-small.png": 690,
	"./med-quindio/Genials-Logo-White.svg": 669,
	"./med-quindio/athenasLoginImage.png": 5380,
	"./med-quindio/athenaslogo.png": 4967,
	"./med-quindio/favin-ico.png": 8608,
	"./med-quindio/genial-logo-white.png": 9026,
	"./med-quindio/logo-DEPR.svg": 7613,
	"./med-quindio/logo-edulab.png": 8025,
	"./med-quindio/logo-gs-lessons.png": 5414,
	"./med-quindio/logo.svg": 8449,
	"./med-quindio/logo_require.png": 2457,
	"./med-rd/GenialSkills-logo-small.png": 2035,
	"./med-rd/Genials-Logo-White.svg": 9092,
	"./med-rd/athenasLoginImage.png": 613,
	"./med-rd/athenaslogo.png": 4638,
	"./med-rd/favin-ico.png": 9069,
	"./med-rd/genial-logo-white.png": 5519,
	"./med-rd/logo-DEPR.svg": 7522,
	"./med-rd/logo-edulab.png": 7628,
	"./med-rd/logo-gs-lessons.png": 835,
	"./med-rd/logo.svg": 8348,
	"./med-rd/logo_require.png": 5454,
	"./msj/GenialSkills-logo-small.png": 16,
	"./msj/Genials-Logo-White.svg": 1095,
	"./msj/athenasLoginImage.png": 3054,
	"./msj/athenaslogo.png": 2717,
	"./msj/favin-ico.png": 6382,
	"./msj/genial-logo-less.png": 3984,
	"./msj/genial-logo-white.png": 8180,
	"./msj/genial-logo.png": 2452,
	"./msj/logo-edulab.png": 1755,
	"./msj/logo-gs-lessons.png": 8920,
	"./msj/logo.svg": 491,
	"./msj/logo_require.png": 6831,
	"./private/GenialSkills-logo-small.png": 6543,
	"./private/Genials-Logo-White.svg": 7662,
	"./private/athenasLoginImage.png": 233,
	"./private/athenaslogo.png": 1722,
	"./private/favin-ico.png": 6985,
	"./private/genial-logo-less.png": 3437,
	"./private/genial-logo-white.png": 523,
	"./private/genial-logo.png": 5019,
	"./private/logo-edulab.png": 5800,
	"./private/logo-gs-lessons.png": 287,
	"./private/logo.svg": 606,
	"./private/logo_require.png": 3194
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5009;